export const FOOTER_ID = 'uni-credit-footer';
